// 全局loading组件
<template>
  <div class="g-loading" v-show="loading">
  <!--<div class="m-loading1">
    <div class="spinner">
      <div class="rect1"></div>
      <div class="rect2"></div>
      <div class="rect3"></div>
      <div class="rect4"></div>
      <div class="rect5"></div>
    </div>
  </div>-->
  <div class="m-loading">
    <i class="i-icon i-icon-loading"></i>
  </div>
</div>
</template>

<script>
export default{
  props: {
    loading:{
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">

.m-loading{
  text-align: center;
  margin-top: 3.8rem;
  .i-icon.i-icon-loading {
    -webkit-animation: btnLoadingKF 2s infinite linear;
    animation: btnLoadingKF 2s infinite linear;

    @keyframes btnLoadingKF {
        from {-webkit-transform: rotate(0deg)}
        to {-webkit-transform: rotate(360deg)}
    }

    @-webkit-keyframes btnLoadingKF {
        from {-webkit-transform: rotate(0deg)}
        to {-webkit-transform: rotate(360deg)}
    }
  }
}

/* loading */
// $bg_blue : #2c82ff; //大背景色
$bg_blue : #2c82ff; //大背景色

.m-loading0{
    .load-container{
        position: relative;
        width: 80px;
        height: 80px;
    }
    .load-container .loader {
        font-size:12px;
        position: absolute;
        top: 50%;
        left: 50%;
        width:8px;
        height:8px;
        margin:-4px 0 0 -4px;
        border-radius: 50%;
        text-indent: -9999em;
        -webkit-animation: loadingKF 1s infinite linear;
        animation: loadingKF 1s infinite linear;
    }
    .loader:after {
        content: '';
        position: absolute;
        top: 0;
    }
    @-webkit-keyframes loadingKF {
        0%,
        100% {
            box-shadow: 0em -2em 0 0.2em $bg_blue, 1.42em -1.42em 0 0em $bg_blue,     2em 0em 0 0em $bg_blue,   1.42em 1.42em 0 0em $bg_blue,   0em 2em 0 0em $bg_blue,   -1.42em 1.42em 0 0em $bg_blue,  -2em 0em 0 0em $bg_blue,  -1.42em -1.42em 0 0em $bg_blue;
        }
        12.5% {
            box-shadow: 0em -2em 0em 0em $bg_blue,   1.42em -1.42em 0 0.2em $bg_blue,   2em 0em 0 0em $bg_blue,      1.42em 1.42em 0 0em $bg_blue,   0em 2em 0 0em $bg_blue,   -1.42em 1.42em 0 0em $bg_blue,  -2em 0em 0 0em $bg_blue,  -1.42em -1.42em 0 0em $bg_blue;
        }
        25% {
            box-shadow: 0em -2em 0em 0em $bg_blue, 1.42em -1.42em 0 0em $bg_blue,    2em 0em 0 0.2em $bg_blue,    1.42em 1.42em 0 0em $bg_blue,      0em 2em 0 0em $bg_blue,   -1.42em 1.42em 0 0em $bg_blue,  -2em 0em 0 0em $bg_blue,  -1.42em -1.42em 0 0em $bg_blue;
        }
        37.5% {
            box-shadow: 0em -2em 0em 0em $bg_blue, 1.42em -1.42em 0 0em $bg_blue, 2em 0em 0 0em $bg_blue,      1.42em 1.42em 0 0.2em $bg_blue,    0em 2em 0 0em $bg_blue,      -1.42em 1.42em 0 0em $bg_blue,  -2em 0em 0 0em $bg_blue,  -1.42em -1.42em 0 0em $bg_blue;
        }
        50% {
            box-shadow: 0em -2em 0em 0em $bg_blue, 1.42em -1.42em 0 0em $bg_blue, 2em 0em 0 0em $bg_blue,   1.42em 1.42em 0 0em $bg_blue,      0em 2em 0 0.2em $bg_blue,    -1.42em 1.42em 0 0em $bg_blue,     -2em 0em 0 0em $bg_blue,  -1.42em -1.42em 0 0em $bg_blue;
        }
        62.5% {
            box-shadow: 0em -2em 0em 0em $bg_blue, 1.42em -1.42em 0 0em $bg_blue, 2em 0em 0 0em $bg_blue,   1.42em 1.42em 0 0em $bg_blue,   0em 2em 0 0em $bg_blue,      -1.42em 1.42em 0 0.2em $bg_blue,   -2em 0em 0 0em $bg_blue,     -1.42em -1.42em 0 0em $bg_blue;
        }
        75% {
            box-shadow: 0em -2em 0em 0em $bg_blue, 1.42em -1.42em 0 0em $bg_blue, 2em 0em 0 0em $bg_blue,   1.42em 1.42em 0 0em $bg_blue,   0em 2em 0 0em $bg_blue,   -1.42em 1.42em 0 0em $bg_blue,     -2em 0em 0 0.2em $bg_blue,   -1.42em -1.42em 0 0em $bg_blue;
        }
        87.5% {
            box-shadow: 0em -2em 0em 0em $bg_blue,   1.42em -1.42em 0 0em $bg_blue,  2em 0em 0 0em $bg_blue,   1.42em 1.42em 0 0em $bg_blue,   0em 2em 0 0em $bg_blue,   -1.42em 1.42em 0 0em $bg_blue,     -2em 0em 0 0em $bg_blue,     -1.42em -1.42em 0 0.2em $bg_blue;
        }
    }
}
.m-loading1{
    .spinner {
        margin: 0 auto;
        width: 50px;
        height: 30px;
        padding: 15px 0;
        text-align: center;
        font-size: 10px;
    }

    .spinner > div {
        background-color: $bg_blue;
        height: 100%;
        width: 6px;
        display: inline-block;

        -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
        animation: stretchdelay 1.2s infinite ease-in-out;
    }

    .spinner .rect2 {
        -webkit-animation-delay: -1.1s;
        animation-delay: -1.1s;
    }

    .spinner .rect3 {
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
    }

    .spinner .rect4 {
        -webkit-animation-delay: -0.9s;
        animation-delay: -0.9s;
    }

    .spinner .rect5 {
        -webkit-animation-delay: -0.8s;
        animation-delay: -0.8s;
    }

    @-webkit-keyframes stretchdelay {
        0%, 40%, 100% { -webkit-transform: scaleY(1) }
        20% { -webkit-transform: scaleY(2.0) }
    }

    @keyframes stretchdelay {
        0%, 40%, 100% { transform: scaleY(1) }
        20% { transform: scaleY(2.0) }
    }
}
</style>



// WEBPACK FOOTER //
// Loading.vue?33747636